import { FC, useState } from 'react';

import { Slideout, SlideoutCommonProps } from 'components/design-system/Slideout';
import auctionStyles from 'styles/Auctions.module.scss';
import { Listing, ProxyBid } from 'types/listing';

import { BidPaymentContent } from './BidPaymentContent';
import { MaxBidExplanation } from './MaxBidExplanation';
import { PlaceBidModalContent } from './PlaceBidModalContent';

export type PlaceBidModalProps = {
  listing: Listing;
  closeModal: () => void;
  refreshListing: (listing: Listing) => void;
  bidValue?: number;
  proxyBid?: ProxyBid;
  refetchProxyBids: () => void;
} & SlideoutCommonProps;

type Sections = 'input' | 'explanation' | 'submit';

export const PlaceBidModal: FC<PlaceBidModalProps> = ({
  listing,
  isOpen,
  closeModal,
  refreshListing,
  bidValue: initialBidValue,
  refetchProxyBids,
  proxyBid
}) => {
  const [visibleSection, setVisibleSection] = useState<Sections>('input');
  const [bidValue, setBidValue] = useState(initialBidValue || 0);

  return (
    <Slideout isOpen={isOpen} closeModal={closeModal} className={auctionStyles.modal}>
      {visibleSection === 'explanation' && <MaxBidExplanation goBack={() => setVisibleSection('input')} />}
      {visibleSection === 'input' && (
        <PlaceBidModalContent
          listing={listing}
          bidValue={bidValue}
          setBidValue={setBidValue}
          onSubmit={() => setVisibleSection('submit')}
          closeModal={closeModal}
          refreshListing={refreshListing}
          showMaxBidExplanation={() => setVisibleSection('explanation')}
          proxyBid={proxyBid}
          refetchProxyBids={refetchProxyBids}
        />
      )}
      {visibleSection === 'submit' && (
        <BidPaymentContent
          refreshListing={refreshListing}
          bidValue={bidValue}
          listing={listing}
          proxyBid={proxyBid}
          refetchProxyBids={refetchProxyBids}
          goBack={() => setVisibleSection('input')}
        />
      )}
    </Slideout>
  );
};
